// prosemirror-history does not export its plugin key
export var pmHistoryPluginKey = 'history$';